module.exports = __webpack_public_path__ + "media/images/clients/viettel-0d4b924d520ce85a36e2a4953e4f08c9.png";